import { Entity, LoadingState } from '@zdr-tools/zdr-entities';
/** Where an in-place edit on the trip page is. */
export var TripFieldEditStep;
(function (TripFieldEditStep) {
    /** The value is shown, not edited. */
    TripFieldEditStep["CLOSED"] = "CLOSED";
    /** The field is open for typing. */
    TripFieldEditStep["EDITING"] = "EDITING";
    /** The save request is in flight; the field cannot be closed. */
    TripFieldEditStep["SAVING"] = "SAVING";
})(TripFieldEditStep || (TripFieldEditStep = {}));
/** Why the last save did not keep the value. */
export var TripFieldEditFailure;
(function (TripFieldEditFailure) {
    TripFieldEditFailure["NONE"] = "NONE";
    /** The value breaks the trip's rule (refused before sending, or by the server). */
    TripFieldEditFailure["INVALID"] = "INVALID";
    /** The trip changed elsewhere since the page showed it; the page now shows the current trip. */
    TripFieldEditFailure["STALE_VERSION"] = "STALE_VERSION";
    /** The server could not be reached or failed. */
    TripFieldEditFailure["UNAVAILABLE"] = "UNAVAILABLE";
})(TripFieldEditFailure || (TripFieldEditFailure = {}));
const NO_ATTEMPT_KEY = '';
/** One in-place edit on the trip page (the title or the note): whether it is open, its save, and the attempt. */
export class TripFieldEdit extends Entity {
    loadingState;
    step;
    failure;
    failureRevision;
    attemptValue = '';
    attemptKey = NO_ATTEMPT_KEY;
    /** `editId` tells the page's edits apart (for example `trip-title-edit`). */
    constructor(editId) {
        super(editId);
        this.loadingState = this.createPropEventBroker('loadingState', LoadingState.IDLE);
        this.step = this.createPropEventBroker('step', TripFieldEditStep.CLOSED);
        this.failure = this.createPropEventBroker('failure', TripFieldEditFailure.NONE);
        this.failureRevision = this.createPropEventBroker('failureRevision', 0);
    }
    getEntityName() {
        return 'TripFieldEdit';
    }
    open() {
        if (this.step.get() === TripFieldEditStep.CLOSED) {
            this.forgetAttempt();
            this.failure.set(TripFieldEditFailure.NONE);
            this.loadingState.set(LoadingState.IDLE);
            this.step.set(TripFieldEditStep.EDITING);
        }
    }
    close() {
        if (this.step.get() === TripFieldEditStep.EDITING) {
            this.forgetAttempt();
            this.failure.set(TripFieldEditFailure.NONE);
            this.step.set(TripFieldEditStep.CLOSED);
        }
    }
    markInvalid() {
        this.recordFailure(TripFieldEditFailure.INVALID);
    }
    markSaving(normalizedValue, freshKey) {
        const isRetry = this.attemptKey !== NO_ATTEMPT_KEY && this.attemptValue === normalizedValue;
        if (!isRetry) {
            this.attemptValue = normalizedValue;
            this.attemptKey = freshKey;
        }
        this.failure.set(TripFieldEditFailure.NONE);
        this.loadingState.set(LoadingState.LOADING);
        this.step.set(TripFieldEditStep.SAVING);
        return this.attemptKey;
    }
    markSaved() {
        this.forgetAttempt();
        this.loadingState.set(LoadingState.DONE);
        this.step.set(TripFieldEditStep.CLOSED);
    }
    markFailed(failure) {
        this.recordFailure(failure);
        this.loadingState.set(LoadingState.ERROR);
        this.step.set(TripFieldEditStep.EDITING);
    }
    recordFailure(failure) {
        this.failure.set(failure);
        this.failureRevision.set(this.failureRevision.get() + 1);
    }
    forgetAttempt() {
        this.attemptValue = '';
        this.attemptKey = NO_ATTEMPT_KEY;
    }
}
//# sourceMappingURL=TripFieldEdit.js.map